<template>
  <div class="card">

    <loading :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="false"></loading>

    <div class="card-body bg-light pt-1 pb-2 px-3">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">

            <label :for="'filterField' + getIdAppendix">{{ $t('text.detailedSearchFieldAndValue.field') }}</label>
            <v-select :options="getSearchableFields" :reduce="item => item.id"
                      :id="'filterField' + getIdAppendix" label="description" class="form-control"
                      v-model="fieldAndValue.filterField"
                      @input="onFilterFieldSelect(true)"
                      :disabled="disabled"
            >
              <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
            </v-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label :for="'filterValue' + getIdAppendix">{{ $t('text.detailedSearchFieldAndValue.value') }}</label>

            <ClassificationClassDropdown v-if="fieldAndValue.filterField === 'EH:klasifikacijska_oznaka_razreda'" :placeholder="$t('text.globals.enterValue')"
                                         :isDisabled="isValueDisabled" :id="'filterValue' + getIdAppendix" :value="fieldAndValue.filterValue"
                                         @knSelected="(val) => { fieldAndValue.filterValue = val; onSelectChange(true) } "></ClassificationClassDropdown>

            <div v-if="fieldAndValue.filterField !== 'EH:klasifikacijska_oznaka_razreda'">
              <div
                  v-if="filterOptions.length == 0 && !isBooleanField(fieldAndValue.filterField) && !isRmaGhostedField(fieldAndValue.filterField) && !isDateField(fieldAndValue.filterField)">
                <input type="text" class="form-control" :id="'filterValue' + getIdAppendix"
                       v-model.trim="fieldAndValue.filterValue"
                       :placeholder="$t('text.detailedSearchFieldAndValue.enterValue')"
                       :disabled="isValueDisabled"

                >
                <!--                            <small><em>Za iskanje s točnim ujemanjem iskalni pojem vstavite v narekovaje.</em></small>-->
              </div>

              <div
                  v-if="filterOptions.length == 0 && isBooleanField(fieldAndValue.filterField)">
                <div class="row">
                  <div class="col-md-3 mt-2">
                    <div class="form-check" :id="'radioButtonFormTrue' + getIdAppendix">
                      <input type="radio"
                             class="form-check-input"
                             :name="'fizicnoGradivo' + getIdAppendix"
                             :value="'true'"
                             v-model="fieldAndValue.filterValue"
                             :id="'fizicnGradivoTrue' + getIdAppendix"
                             :disabled="isValueDisabled"

                      >

                      <label :for="'fizicnGradivoTrue' + getIdAppendix"
                             style="line-height: 28px;">{{ $t('text.globals.yes') }}</label>
                    </div>
                  </div>
                  <div class="col-md-3 mt-2"
                       v-if="fieldAndValue && fieldAndValue.filterField !== 'EH:pregledan_za_izrocanje'">
                    <div class="form-check" :id="'radioButtonFormFalse' + getIdAppendix">
                      <input type="radio"
                             class="form-check-input"
                             :name="'fizicnoGradivo' + getIdAppendix"
                             v-model="fieldAndValue.filterValue"
                             :value="'false'"
                             :id="'fizicnGradivoFalse' + getIdAppendix"
                             :disabled="isValueDisabled"
                      >

                      <label :for="'fizicnGradivoFalse' + getIdAppendix"
                             style="line-height: 28px;">{{ $t('text.globals.no') }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div
                  v-if="filterOptions.length == 0 && isRmaGhostedField(fieldAndValue.filterField)">
                <div class="row">
                  <div class="col-md-3 mt-2">
                    <div class="form-check" :id="'rmaGhostedFormTrue' + getIdAppendix">
                      <input type="radio"
                             class="form-check-input"
                             :name="'rmaGhosted' + getIdAppendix"
                             :value="'true'"
                             v-model="fieldAndValue.filterValue"
                             :id="'rmaGhostedTrue' + getIdAppendix"
                             :disabled="isValueDisabled"

                      >

                      <label :for="'fizicnGradivoTrue' + getIdAppendix"
                             style="line-height: 28px;">{{ $t('text.globals.yes') }}</label>
                    </div>
                  </div>
                  <div class="col-md-3 mt-2">
                    <div class="form-check" :id="'rmaGhostedFalse' + getIdAppendix">
                      <input type="radio"
                             class="form-check-input"
                             :name="'rmaGhosted' + getIdAppendix"
                             v-model="fieldAndValue.filterValue"
                             :value="'false'"
                             :id="'rmaGhostedFalse' + getIdAppendix"
                             :disabled="isValueDisabled"
                      >

                      <label :for="'rmaGhostedFalse' + getIdAppendix"
                             style="line-height: 28px;">{{ $t('text.globals.no') }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="filterOptions.length == 0 && isDateField(fieldAndValue.filterField)">
                <VueCtkDateTimePicker :id="'selectedDate' + getIdAppendix" format="YYYY-MM-DD"
                                      :label="$t('text.detailedSearchFieldAndValue.selectDate')"
                                      :locale="$t('text.globals.datePickerLocale')"
                                      :noLabel="true"
                                      :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"
                                      :range="true"
                                      :auto-close="false"
                                      @is-hidden="validateSelectedDateRange"
                                      formatted="DD.MM.YYYY, HH:mm"
                                      v-model="fieldAndValue.filterValue" :only-date="true"
                                      :disabled="isValueDisabled"
                                      :button-now-translation="$t('text.globals.now')"

                />
              </div>

              <v-select :options="filterOptions"
                        v-if="filterOptions.length > 0 && fieldAndValue.filterField !== 'EH:klasifikacijska_oznaka_razreda'"
                        :reduce="item => (fieldAndValue.filterField !== 'EH:klasifikacijska_oznaka_razreda' ? item.id : item.classificationLabel)"
                        :id="'filterValue' + getIdAppendix"
                        :label="'description'"
                        class="form-control"
                        @input="onSelectChange(true)"
                        v-model="fieldAndValue.filterValue"
                        :disabled="isValueDisabled"
              >
                <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>

                <template v-slot:option="option">

                  {{ option.description }} <small class="pl-2 text-muted"
                                                  v-if="option.connectedSystem">({{
                    $t('text.classificationPlanMetadata.connectedSystem')
                  }}:
                  {{ option.connectedSystem }})</small>
                  <small class="pl-2 text-muted"
                         v-if="fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema'">({{ option.id }})</small>

                </template>
                <template v-slot:selected-option="option">

                  {{ option.description }} <small class="pl-2 text-muted"
                                                  v-if="option.connectedSystem">({{
                    $t('text.classificationPlanMetadata.connectedSystem')
                  }}:
                  {{ option.connectedSystem }})</small>
                  <small class="pl-2 text-muted"
                         v-if="fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema'">({{ option.id }})</small>

                </template>


              </v-select>

            </div>
          </div>

          <div class="form-group" v-if="fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema'">
            <label
                :for="'filterVpisnikiValue' + getIdAppendix">{{
                $t('text.classificationPlanMetadata.registries')
              }}</label>

            <v-select :options="vpisnikiOptions"
                      :reduce="item => item.id"
                      :id="'filterValue2' + getIdAppendix"
                      label="description"
                      class="form-control mt-1"
                      :multiple="true"
                      v-model="fieldAndValue.filterVpisnikiValue"
                      :disabled="isValueDisabled"

            >
              <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>

              <template v-slot:option="option">
                {{ option.description }} <small class="pl-2 text-muted"
                                                v-if="option.connectedSystem">({{
                  $t('text.classificationPlanMetadata.connectedSystem')
                }}:
                {{ option.connectedSystem }})</small>
                <small class="pl-2 text-muted"
                       v-if="fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema'">({{ option.id }})</small>
              </template>
              <template v-slot:selected-option="option">
                {{ option.description }} <small class="pl-2 text-muted"
                                                v-if="option.connectedSystem">({{
                  $t('text.classificationPlanMetadata.connectedSystem')
                }}:
                {{ option.connectedSystem }})</small>
                <small class="pl-2 text-muted"
                       v-if="fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema'">({{ option.id }})</small>
              </template>


            </v-select>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import flatten from "flat";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import convert from "xml-js";
import ClassificationClassDropdown from "./ClassificationClassDropdown";

export default {
  name: 'DetailedSearchFieldAndValue',
  components: {
    vSelect,
    Loading,
    ClassificationClassDropdown
  },
  props: {
    index: Number,
    fieldAndValue: {
      filterField: String,
      filterValue: String,
      filterVpisnikiValue: String
    },
    disabled: Boolean,
    searchableFields: Array,
    allMetadataOptions: Array,
  },

  data() {
    return {
      filterOptions: [],
      vpisnikiOptions: [],
      isValueDisabled: null,
      codeList: [],
      isLoading: false,
    };
  },
  beforeUpdate() {

  },
  mounted() {
    const _this = this;

    this.isValueDisabled = (this.disabled || (this.fieldAndValue.filterField == null));


    let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");
    Promise.all([p1]).then((values) => {
      console.log("mounted", "mounted");
      _this.codeList = _this.$store.getters.getCodeListProperties
      console.log("this.fieldAndValue.filterField", this.fieldAndValue.filterField);

      setTimeout(function () {
        _this.onFilterFieldSelect(false);
        if (_this.fieldAndValue && _this.fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema') {
          _this.onSelectChange(false);
        }
      }, 100);


    });
  },
  computed: {

    getSearchableFields() {
      const _this = this;

      return _.sortBy(_this.searchableFields, [function (o) {
        return o.description;
      }]);
    },

    getIdAppendix() {
      let idVal = "";

      if (this.index === 0) {
        idVal = "One";
      } else if (this.index === 1) {
        idVal = "Two";
      } else if (this.index === 2) {
        idVal = "Three";
      }

      return idVal;
    }

  },
  watch: {
    disabled: function (val) {
      this.isValueDisabled = (this.disabled || (this.fieldAndValue.filterField == null));
    }


  },

  methods: {

    validateSelectedDateRange() {
      if (this.fieldAndValue.filterValue && this.fieldAndValue.filterValue.start && this.fieldAndValue.filterValue.end === null) {
        let start = this.fieldAndValue.filterValue.start;
        let now = this.moment();

        if (now > this.moment(start, 'YYYY-MM-DD')) {
          this.fieldAndValue.filterValue.end = now.format('YYYY-MM-DD');
        } else {
          this.fieldAndValue.filterValue.start = now.format('YYYY-MM-DD');
          this.fieldAndValue.filterValue.end = start;
        }

      }
    },

    async onFilterFieldSelect(forceChange) {

      this.isValueDisabled = (this.disabled || (this.fieldAndValue.filterField == null));

      const _this = this;
      console.log("filterField -> ", _this.fieldAndValue.filterField)
      console.log("allMetadataOptions -> ", _this.allMetadataOptions)

      if (forceChange) {
        _this.fieldAndValue.filterValue = '';
        _this.vpisnikiOptions = [];
        _this.fieldAndValue.filterVpisnikiValue = '';
      }

      let isKeyCode = false;
      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (property === _this.fieldAndValue.filterField) {
          console.log("val.body", val.body);

          if (_this.fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema' || _this.fieldAndValue.filterField === 'EH:ciljni_povezan_sistem') {
            let ehrambaPovezaniSistemi = [];
            _.each(val.body, function (innerItem) {
              if (innerItem.ehramba) {
                ehrambaPovezaniSistemi.push(innerItem);
              }
            });
            _this.filterOptions = ehrambaPovezaniSistemi;
          } else if (_this.fieldAndValue.filterField === 'EH:oznaka_vpisnika') {

            let optionsPovezaniSistemi = _.filter(_this.allMetadataOptions, {property: 'EH:oznaka_povezanega_sistema'})[0].body;
            let filteredOptionsPovezaniSistemi = _.filter(optionsPovezaniSistemi, {ehramba: true});

            let filteredVpisniki = [];

            _.forEach(filteredOptionsPovezaniSistemi, function (value, key) {
              _.each(val.body, function (_val, _key) {
                if (value.id === _val.connectedSystem) {
                  filteredVpisniki.push(_val);
                }
              });
            });

            _this.filterOptions = filteredVpisniki;
          } else if (_this.fieldAndValue.filterField === 'EH:koncni_format') {
            let options = [];
            _.each(val.body, function (_val) {
              options.push({
                id: _val.id,
                description: _val.code + ' (' + _val.description + ')'
              })
            });
            _this.filterOptions = options;

          } else if (_this.fieldAndValue.filterField === 'EH:izvorna_oblika') {
            let options = [];
            _.each(val.body, function (_val) {
              options.push({
                id: _val.id,
                description: _val.mimetype + ' (' + _val.documentFormat.description + ')'
              })
            });
            _this.filterOptions = options;

          } else if (_this.fieldAndValue.filterField === 'EH:rok_hrambe') {
            let options = [];
            _.each(val.body, function (_val) {
              options.push({
                id: _val.id,
                description: _val.explanation
              })
            });
            _this.filterOptions = options;

          } else {
            _this.filterOptions = val.body;
          }
          isKeyCode = true;
        }
      });


      if (!isKeyCode) {
        _this.filterOptions = [];
      }

      if (_this.fieldAndValue.filterField === 'EH:pregledan_za_izrocanje') {
        _this.fieldAndValue.filterValue = true;
      }


    },

    onSelectChange(forceChange) {
      const _this = this;

      if (forceChange) {
        _this.vpisnikiOptions = [];
        _this.fieldAndValue.filterVpisnikiValue = '';
      }

      if (_this.fieldAndValue.filterField === 'EH:oznaka_povezanega_sistema') {
        console.log("_this.fieldAndValue.filterValue", _this.fieldAndValue.filterValue);

        _.each(_this.allMetadataOptions, function (val, key) {
          let property = val.property;

          if (property === 'EH:oznaka_vpisnika') {
            console.log("val.body", val.body);
            _.each(val.body, function (innerItem) {
              if (innerItem.connectedSystem === _this.fieldAndValue.filterValue) {
                _this.vpisnikiOptions.push(innerItem);
              }
            })
          }
        });

      }
    },

    isDateField(field) {
      let dateFields = [
        'EH:datum_gradiva',
        'EH:datum_izteka_roka_hrambe',
        'EH:datum_pregleda_izrocanje',
        'EH:datum_pregleda',
        'EH:format_datum_preverbe',
        'EH:datum_unicenja',
        'EH:datum_zacetka_teka_roka_hrambe',
        'EH:izroceno_dne',
        'EH:datum_zadnje_spremembe_statusa_gradiva'
      ]
      return dateFields.includes(field);
    },

    isBooleanField(field) {
      let booleanFields = [
        'EH:fizicno_gradivo',
        'EH:gradivo_e_podpisano',
        'EH:izroceno',
        'EH:prevzeto',
        'EH:pretvorjeno_gradivo',
        'EH:pregledan_za_izrocanje',
        'EH:izbris_originala',
      ]
      return booleanFields.includes(field);
    },

    isRmaGhostedField(field) {
      let rmaGhostedFields = [
        'rma:ghosted'
      ]
      return rmaGhostedFields.includes(field);
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/DetailedSearchFieldAndValue.vue